import { callGet } from "../integrations/calls";
// import { callGet, callPost, callPutById, callDelete } from "../integrations/calls";


import { REQ } from "../../libs/constants";

export const getAllItemsSearch = async (token) => {
    return await callGet(`${REQ.SEARCH.ALL_ITEMS}`, token)
}

export const getAllPartySearch = async (token) => {
    return await callGet(`${REQ.SEARCH.GET_ALL_PARTY}`, token)
}

export const getAllSupplierSearch = async (token) => {
    return await callGet(`${REQ.SEARCH.GET_SUPPLIER_PARTY}`, token)
}

export const getAllCardSearch = async (token) => {
    return await callGet(`${REQ.SEARCH.GET_CARD_PARTY}`, token)
}

export const getAllGeneralLedger= async (token)=>{
    return await callGet(`${REQ.SEARCH.GET_GENERAL_LEDGER}`, token)   
}

export const getExpGeneralLedger= async (token)=>{
    return await callGet(`${REQ.SEARCH.GET_EXPENSE_GENERAL_LEDGER}`, token)   
}

export const getBulkPermission= async (token)=>{
    return await callGet(`${REQ.SEARCH.GET_BULK_PERMISSION}`, token)   
}

export const getAllBank= async (token)=>{
    return await callGet(`${REQ.SEARCH.GET_BANK}`, token)   
}
export const getSingleItem= async (id, token)=>{
    return await callGet(`${REQ.SEARCH.GET_SINGLE_ITEM}/${id}`, token)   
}